/**
 * 初回パスワード設定・再設定（FR-111/112②・C-15）。
 *
 * ワンタイムURL（`/password/setup?token=…`）で開く。**未ログインで開く画面**。
 */

import { ApiError, auth } from "@kenzai/api-client";
import { AuthCard, Button, Field, FormError } from "@kenzai/ui";
import { useState } from "react";

const MIN_LENGTH = 12; // 03 §4.1（サーバ側 password_min_length と対）

export function PasswordSetup() {
  const token = new URLSearchParams(window.location.search).get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <AuthCard title="パスワードの設定" subtitle="URLが正しくありません">
        <FormError message="このURLは無効です。お手数ですが、発行元にご確認ください。" />
      </AuthCard>
    );
  }

  if (done) {
    return (
      <AuthCard title="設定が完了しました" subtitle="新しいパスワードでログインしてください">
        <Button fullWidth onClick={() => (window.location.href = "/")}>ログイン画面へ</Button>
      </AuthCard>
    );
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    // 確認欄の一致はクライアントで見る（打ち間違いの検出＝サーバの仕事ではない）。
    // 長さ・漏洩辞書の判定は**サーバが正**（03 §4.1）＝ここでは先回りして案内するだけ。
    if (password !== confirm) {
      setError("確認用のパスワードが一致しません。");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await auth.setupPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "設定できませんでした。");
      setBusy(false);
    }
  }

  return (
    <AuthCard title="パスワードの設定" subtitle="建材オーダー 卸コンソール">
      <form onSubmit={submit} noValidate data-testid="setup-form">
        <FormError message={error} />
        <Field
          label="新しいパスワード"
          type="password"
          name="new-password"
          autoComplete="new-password"
          required
          hint={`${MIN_LENGTH}文字以上。よく使われるパスワードは設定できません。`}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Field
          label="新しいパスワード（確認）"
          type="password"
          name="confirm-password"
          autoComplete="new-password"
          required
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        <Button fullWidth type="submit" busy={busy} disabled={password.length < MIN_LENGTH}>
          設定する
        </Button>
      </form>
    </AuthCard>
  );
}
